import * as api from '@utils/api'
import { StoreList } from '@types'

export const getStoreList = async (): Promise<StoreList> => {
  const response = await api.GET('/p4/stores')

  return response.data.stores
}
